/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ volumeText: NonNullable<unknown> }} Wrapped_Tonnes_LiftedInputs */

const en_us2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} lifted`)
};

const pt_br2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantadas`)
};

const es_419_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados`)
};

const pt_pt2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} levantados`)
};

const fr_fr2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} de charge soulevée`)
};

const de_de2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} bewegt`)
};

const it_it2_wrapped_tonnes_lifted = /** @type {(inputs: Wrapped_Tonnes_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.volumeText} sollevati`)
};

/**
* | output |
* | --- |
* | "{volumeText} lifted" |
*
* @param {Wrapped_Tonnes_LiftedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_tonnes_lifted = /** @type {((inputs: Wrapped_Tonnes_LiftedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Tonnes_LiftedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_tonnes_lifted(inputs)
	if (locale === "es-419") return es_419_wrapped_tonnes_lifted(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_tonnes_lifted(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_tonnes_lifted(inputs)
	if (locale === "de-DE") return de_de2_wrapped_tonnes_lifted(inputs)
	if (locale === "it-IT") return it_it2_wrapped_tonnes_lifted(inputs)
	return en_us2_wrapped_tonnes_lifted(inputs)
});
export { wrapped_tonnes_lifted as "wrapped.tonnes_lifted" }